import { SitesView } from '../../../_generated';
import { SitesAction, SitesActionType } from '../../actionstypes/sites/sites.actiontype';

const initialState: SitesView[] = [];

export default (state = initialState, action: SitesActionType): SitesView[] => {
  switch (action.type) {
    case SitesAction.Get:
      return action.payload;

    case SitesAction.Reset:
      return [];

    case SitesAction.UpdateParameterStatus: {
      const { siteId, shopId, toolId, emissionPointId, parameterId, status } = action.payload;

      return state.map((site) => {
        if (site.id !== siteId) return site;
        return {
          ...site,
          shops: site.shops.map((shop) => {
            if (shop.id !== shopId) return shop;

            return {
              ...shop,
              tools: shop.tools.map((tool) => {
                if (tool.id !== toolId) return tool;

                return {
                  ...tool,
                  emissionPoints: tool.emissionPoints.map((emissionPoint) => {
                    if (emissionPoint.id !== emissionPointId) return emissionPoint;

                    return {
                      ...emissionPoint,
                      parameters: emissionPoint.parameters.map((parameter) => {
                        if (parameter.id !== parameterId) return parameter;
                        return {
                          ...parameter,
                          status,
                        };
                      }),
                    };
                  }),
                };
              }),
            };
          }),
        };
      });
    }

    default:
      return state;
  }
};
